module.exports = new __parcel__URL__("myFlixPostmanExample.4a071489.png").toString();